// extracted by mini-css-extract-plugin
export default {"banner":"TZ","wrapper":"UZ","selected_products":"VZ","images":"WZ","img":"XZ","rounded_arrow":"YZ","image-enter":"ZZ","image-enter-active":"a-","image-enter-done":"b-","image-exit":"c-","image-exit-active":"e-"};
    if(module.hot) {
      // 1715188239352
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  